<div class="modal-header">
  <h4 class="modal-title reportCancelModal__title">
    Cancelar reporte
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Cerrar"
    (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body reportCancelModal">
  @if (!loading) {
    <form
      id="formReportCancel"
      [formGroup]="formReportCancel"
      (ngSubmit)="onSubmit()">
      <div class="container-fluid px-0">
        <div class="row">

          <!-- Qué se va a cancelar, como texto de solo lectura FUERA de los
               inputs: el reporte es contexto, no un campo editable. -->
          <div class="col-12 mb-3">
            <div class="reportCancelModal__meta">

              <p class="reportCancelModal__metaRow d-flex mb-1">
                <span class="reportCancelModal__metaLabel">Reporte</span>
                <span class="reportCancelModal__metaValue text-truncate" [title]="report.title">
                  {{ report.title }}
                </span>
              </p>

              <p class="reportCancelModal__metaRow d-flex mb-0">
                <span class="reportCancelModal__metaLabel">Estado actual</span>
                <span class="reportCancelModal__metaValue text-truncate">
                  {{ report.statusLabel }}
                </span>
              </p>

            </div>
          </div>

          <!-- Advertencia: se explica qué hace cancelar ANTES de pedir el
               motivo, para que la decisión se tome con el dato completo. -->
          <div class="col-12 mb-4">
            <p class="reportCancelModal__notice mb-0 d-flex align-items-start">
              <i class="material-icons reportCancelModal__noticeIcon" aria-hidden="true">info</i>
              <span>
                El reporte no se borra: queda registrado como cancelado, con tu
                nombre y el motivo. Después de cancelarlo ya no se podrá mover
                de estado.
              </span>
            </p>
          </div>

          <!-- ---------------------------------------------------------------- -->
          <!--                       ANCHOR CANCEL REASON                       -->
          <!-- ---------------------------------------------------------------- -->
          <div class="col-12 form-group mb-2">
            <label htmlFor="reportCancelReason" class="form-label">
              {{ dataForm['cancelReason'].label }}
            </label>
            <textarea
              id="reportCancelReason"
              rows="3"
              class="form-control"
              formControlName="cancelReason"
              [placeholder]="dataForm['cancelReason'].placeholder ?? dataForm['cancelReason'].label"
              [attr.aria-invalid]="submitted && f['cancelReason'].errors ? 'true' : null"
              [attr.aria-describedby]="submitted && f['cancelReason'].errors ? 'reportCancelReasonError' : 'reportCancelReasonHelp'"
              [ngClass]="{
                'is-invalid': submitted && f['cancelReason'].errors
              }"></textarea>

            <!-- Contador derivado: fuera del campo, como texto de apoyo. -->
            <div class="d-flex justify-content-between gap-2 mt-1">
              <span id="reportCancelReasonHelp" class="reportCancelModal__help">
                Lo verá cualquier administrador que abra el reporte.
              </span>
              <span
                class="reportCancelModal__counter"
                [ngClass]="{
                  'reportCancelModal__counter--over': (f['cancelReason'].value?.length ?? 0) > reasonMaxLength
                }">
                {{ f['cancelReason'].value?.length ?? 0 }}/{{ reasonMaxLength }}
              </span>
            </div>

            @if (submitted && f['cancelReason'].errors) {
              <div class="invalid-feedback d-block" id="reportCancelReasonError">
                @if (f['cancelReason'].errors!['required']) {
                  <div>{{ dataForm['cancelReason'].requiredMessage }}</div>
                }
                @if (f['cancelReason'].errors!['maxlength']) {
                  <div>El motivo no puede tener más de {{ reasonMaxLength }} caracteres.</div>
                }
              </div>
            }
          </div>

        </div>
      </div>
    </form>
  }
</div>

<div class="modal-footer">
  <div class="col-12 my-3">
    <button
      (click)="activeModal.dismiss()"
      type="button"
      class="btn btn-outline-secondary w-100 reportCancelModal__actionBtn">
      Volver
    </button>
  </div>
  <div class="col-12">
    <!-- Nunca deshabilitado: la validación se resuelve en onSubmit(). -->
    <button
      type="submit"
      form="formReportCancel"
      class="btn btn-danger w-100 reportCancelModal__actionBtn">
      Cancelar reporte
    </button>
  </div>
</div>
